import { useQueryClient, type QueryKey } from "@tanstack/react-query";

import { queryKey } from "../../../api/endpoints";
import type { AdminPersonView, WorkspaceAdminView } from "../../../api/types";

const PEOPLE = queryKey("admin_people", {}) as unknown as QueryKey;
const WORKSPACES = queryKey("admin_workspaces", {}) as unknown as QueryKey;

/** Put an account the server just returned into the list on the screen, then read the list again. */
export function usePeopleCache() {
  const queryClient = useQueryClient();
  return {
    replace(person: AdminPersonView) {
      queryClient.setQueryData<AdminPersonView[]>(PEOPLE, (list) => {
        if (!list) return list;
        return list.some((entry) => entry.id === person.id) ? list.map((entry) => (entry.id === person.id ? person : entry)) : [...list, person];
      });
      void queryClient.invalidateQueries({ queryKey: ["admin_people"] });
    },
  };
}

/** The same for disciplines. */
export function useWorkspaceCache() {
  const queryClient = useQueryClient();
  return {
    replace(workspace: WorkspaceAdminView) {
      queryClient.setQueryData<WorkspaceAdminView[]>(WORKSPACES, (list) => {
        if (!list) return list;
        return list.some((entry) => entry.code === workspace.code) ? list.map((entry) => (entry.code === workspace.code ? workspace : entry)) : [...list, workspace];
      });
      void queryClient.invalidateQueries({ queryKey: ["admin_workspaces"] });
    },
  };
}
